import React from 'react';
import CatalogueRowTitle from './CatalogueRowTitle';
import CatalogueRowCarousel from './CatalogueRowCarousel';
import { CatalogueSection } from '../../../models';

interface CatalogueRowProps {
  section: CatalogueSection;
}

function CatalogueRow({ section }: CatalogueRowProps) {
  return (
    <div className="flex flex-col">
      <CatalogueRowTitle category={section.category} />
      <CatalogueRowCarousel />
    </div>
  );
}

export default CatalogueRow;
